import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import {
	MAT_DIALOG_DATA,
	MatDialogTitle,
	MatDialogContent,
	MatDialogActions,
	MatDialogClose,
} from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@tolgee/ngx";

@Component({
	selector: "app-error-modal",
	templateUrl: "./error-modal.component.html",
	styleUrls: ["./error-modal.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, TranslatePipe],
})
export class ErrorModalComponent {
	message = inject(MAT_DIALOG_DATA);
}
